<template>
  <div class="live-input" :class="cssClass">
    <component ref="input" :is="inputType" :state="currentState" :value="value" :errors="errors"
               v-on="$listeners" v-bind="$attrs" class="d-inline-block"/>
    <div class="form-text form-label">
      {{ label }}
      <span v-if="hint" v-b-tooltip.hover :title="hint"><i class="btr bt-info-circle"></i></span>
    </div>
    <div class="form-text form-errors" v-if="errors">{{ errors.join(', ') }}</div>
  </div>
</template>

<script>
import baseInput from './live-input/_base'
import AddressInput from './live-input/address-input'
import CheckboxesInput from './live-input/checkboxes-input'
import ToggleInput from './live-input/toggle-input'
import SelectInput from './live-input/select-input'
import TextInput from './live-input/text-input'
import ReadOnlyInput from './live-input/read-only-input'
import TextAreaInput from './live-input/text-area-input'
import TimeRangeInput from './live-input/time-range-input'
import DateInput from './live-input/date-input'

const INPUT_TYPES = {
  text: TextInput,
  readonly: ReadOnlyInput,
  textarea: TextAreaInput,
  select: SelectInput,
  address: AddressInput,
  checkboxes: CheckboxesInput,
  toggle: ToggleInput,
  date: DateInput,
  ['time-range']: TimeRangeInput,
}

export default {
  mixins: [baseInput],

  props: {
    as: { type: String, default: 'text' },
    label: { type: String },
    hint: { type: String },
    inline: { type: Boolean, default: false },
  },

  data() {
    return {
      inputType: INPUT_TYPES[this.as] || TextInput,
      currentDirty: this.dirty,
      selfUpdate: false,
    }
  },

  computed: {
    cssClass() {
      return {
        [`live-input--${this.as || 'text'}`]: true,
        dirty: this.dirty,
        ['d-inline-block']: this.inline,
      }
    },

    currentState() {
      return this.errors ? this.errors.length === 0 : null
    },
  },

  components: {
    AddressInput,
    ReadOnlyInput,
    SelectInput,
    TextInput,
    TextAreaInput,
    CheckboxesInput,
    ToggleInput,
    DateInput,
  },
}
</script>

<style lang="scss">
.live-input {
  position: relative;

  .form-control {
    border-width: 2px;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  h1 & .form-control {
    padding-top: 2.75rem;
  }

  .form-control:not(:focus) {
    border-bottom-color: transparent;
  }

  .form-control:focus ~ .form-label {
    color: $secondary;
  }

  .form-label {
    span {
      color: $secondary;
      font-size: $font-size-sm;
      vertical-align: middle;
      margin-left: map_get($spacers, 0);
    }
  }

  .form-errors {
    color: $danger;
  }

  .form-errors, .form-label {
    position: absolute;
    letter-spacing: 0.83px;
    font-size: $font-size-xxs;
    text-transform: uppercase;
    left: calc(1.2rem + 2px);
    top: -0.625rem;
  }

  .is-invalid ~ .form-label {
    display: none;
  }

  &.dirty {
    .form-control:not(:focus) {
      border-left-color: $primary;
      border-bottom-color: transparent;
    }

    .is-invalid:not(:focus) {
      border-left-color: $danger;
    }
  }
}
</style>